export const SAVE_CUSTOMER_DETAIL = 'SAVE_CUSTOMER_DETAIL'
export const SAVE_CUSTOMER_KEYS = 'SAVE_CUSTOMER_KEYS'
export const CLEAR_STORE = 'CLEAR_STORE'
